type AuthRegexKey = 'numbers' | 'upperCase' | 'lowerCase' | 'special' | 'onlyLowercaseAndNumbersAndUnderscore';
type AuthCountKey = 'minLength' | 'maxLength' | 'minLowerCase' | 'minUpperCase' | 'minNumbers' | 'minSpecial';

export class AuthConfig {
  public static regex: { [key in AuthRegexKey]?: RegExp } = {
    numbers: /\d/g,
    // avoid `g` flag for the following rules
    // (see issue https://github.com/typestack/class-validator/issues/484#issuecomment-595821457)
    upperCase: /[A-Z\u00c4\u00d6\u00dc]/,
    lowerCase: /[a-z\u00e4\u00f6\u00fc\u00df]/,
    special: /[<>{}\"/|;:.,\-_+'`´~!?@#$%^=&*\]\\()\[¿§«»ω⊙¤°℃℉€¥£¢¡®©]/,
    // Allowed characters: a-z, 0-9, "_-."
    onlyLowercaseAndNumbersAndUnderscore: /^[a-z0-9_\-.]$/,
  };

  // IMPORTANT: current settings should pass password security requirements Level 2
  // removing/lowering some of these values may violate password security requirements!
  // (see OWASP V2.1 Password Security Requirements for more info)
  //
  // If changing values is really necessary,
  // you currently have to update "password rules" in api/src/static/password-reset/index.html as well
  public static password: { [key in AuthCountKey]?: number } = {
    minLength: 12,
    maxLength: 128,
    minLowerCase: 1,
    minUpperCase: 1,
    minNumbers: 1,
    minSpecial: 1,
  };

  public static username: { minLength: number, maxLength: number } = {
    minLength: 5,
    maxLength: 30,
  }
}
